"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title1: function() {
        return _index.Title1;
    },
    title1ClassNames: function() {
        return _index.title1ClassNames;
    }
});
const _index = require("./components/presets/Title1/index");
